export default __webpack_public_path__ + "static/media/fireFN32.4aab5e9d.svg";